export default __webpack_public_path__ + "static/media/WorkStation2.620021d0.jpg";